import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n';
import { homePathFor } from '../i18n/localePath';

const NotFound: React.FC = () => {
  const { t, language } = useLanguage();

  return (
    <section className="lp-wrap" style={{ padding: '48px 0 80px' }} aria-labelledby="not-found-title">
      <h1 id="not-found-title" className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
        {t.notFound.title}
      </h1>
      <p className="text-gray-700 mb-6 max-w-xl">{t.notFound.body}</p>
      <Link className="lp-button" to={homePathFor(language)}>
        <span>{t.notFound.home}</span>
      </Link>
    </section>
  );
};

export default NotFound;
